export class ConfirmController {
    static $inject = ['$uibModalInstance', 'title', 'message', 'btnOk'];

    constructor(private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance, 
        private title: any, 
        private message: any,
        private btnOk: any) {
    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    };
}




// WEBPACK FOOTER //
// ./src/components/common/confirmation.ts